export default {
  'verification': {
    'search_title': '检测管理',
    'search_create': '创建检测报告'
  },
  'on_road': {
    'report_number': '检测报告编号',
    'owner_name': '车主姓名（单位）',
    'owner_contact': '联系电话',
    'license_plate_number': '号牌号码',
    'vehicle_model': '车辆型号',
    'inspection_result': '检测结果',
    'inspector': '检测员',
    'reviewer': '审核员',
    'approver': '批准员',
    'approval_date': '批准时间',
    'created_at': '创建时间',
    'updated_at': '更新时间'
  }
}
